import React from 'react';
import Avatar from '@mui/material/Avatar';
import './../../../../../../../themes/uc_base_theme/assets/css/edge.css'

interface IEdgeBorderedAvatarProps {
    thumbnailUrl: string;
    alt?: string;
    edges?: { top: boolean; bottom: boolean; left: boolean; right: boolean };
    /**
     * Azok az oldalak, amiket az adott lapnál eleve NEM lehet élzárni (nincs hozzá gomb). Ezeket
     * szaggatott, halvány kerettel jelöljük, hogy ne mosódjon össze a "nincs kiválasztva" állapottal —
     * pl. a munkalapnál nincs Top él. Ha nincs megadva, semmi nem változik.
     */
    unavailable?: { top: boolean; bottom: boolean; left: boolean; right: boolean };
    size?: number;
    /** Keresztirányú szálirány (Cross) esetén a mintát 90°-kal elforgatjuk, ahogy a Unity is teszi. */
    rotated?: boolean;
}

/** A nem élzárható oldal jelzése: szaggatott, halvány keret (ugyanolyan széles, mint az élzárás-keret). */
export const UNAVAILABLE_EDGE_BORDER = "5px dashed rgba(255, 255, 255, 0.35)";

const EdgeBorderedAvatar: React.FC<IEdgeBorderedAvatarProps> = ({ thumbnailUrl, alt, edges, unavailable, size = 56, rotated = false }) => {
    // Az élzárás-keret (fehér, folytonos) ELŐBBRE való: ha egy oldal élzárt, azt jelöljük, nem a
    // "nem választható" állapotot (a kettő normál esetben kizárja egymást).
    const borderStyles = {
        ...(unavailable?.top && { borderTop: UNAVAILABLE_EDGE_BORDER }),
        ...(unavailable?.right && { borderRight: UNAVAILABLE_EDGE_BORDER }),
        ...(unavailable?.bottom && { borderBottom: UNAVAILABLE_EDGE_BORDER }),
        ...(unavailable?.left && { borderLeft: UNAVAILABLE_EDGE_BORDER }),
        ...(edges?.top && { borderTop: "5px solid white" }),
        ...(edges?.right && { borderRight: "5px solid white" }),
        ...(edges?.bottom && { borderBottom: "5px solid white" }),
        ...(edges?.left && { borderLeft: "5px solid white" }),
    };

    return (
        <Avatar
            className={"hasEdgeBorder"}
            alt={alt}
            src={thumbnailUrl}
            variant="rounded"
            sx={{
                width: size,
                height: size,
                // Csak a mintázatot (a belső img-et) forgatjuk; az él-borderek a ::after-en
                // maradnak, így a helyükön rögzülnek.
                '& img': {
                    transform: rotated ? 'rotate(-90deg)' : 'none',
                },
                '&::after': {
                    ...borderStyles,
                    pointerEvents: 'none',
                },
            }}
        />
    );
};

export default EdgeBorderedAvatar;